import React from "react";
import { useEffect, useState } from "react";
import {
  Button,
  Card,
  FormControl,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    border: "1px solid #386E5B",
    textAlign: "center",
  },
  tableCell: {
    padding: "5px 0px",
    border: "1px solid #386E5B",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function AdminDeliveryVehicleDetail() {
  // Navigate
  const navigate = useNavigate();
  const id = useParams();

  // Styling
  const styles = useStyles();

  // Redux Data
  const data = useSelector((state) => state.deliveryVehicle.data);

  // Local State
  const [formData, setFormData] = useState({
    numberPlate: "",
    brand: "",
    model: "",
    vehicleType: "",
  });
  const [fetch, setFetch] = useState(true);

  useEffect(() => {
    if (fetch) {
      const x = data.docs.findIndex((item) => item._id === id.id);
      if (x > -1) {
        setFormData({
          numberPlate: data.docs[x].numberPlate ? data.docs[x].numberPlate : "",
          brand: data.docs[x].brand ? data.docs[x].brand : "",
          model: data.docs[x].model ? data.docs[x].model : "",
          vehicleType: data.docs[x].vehicleType ? data.docs[x].vehicleType : "",
        });
      } else {
        toast.error("Data tidak ditemukan");
      }
      setFetch(false);
    }
  }, [fetch]);

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          DETAIL KENDARAAN PENGIRIMAN
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{ display: "flex", flexDirection: "column", width: "100%" }}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              NO PLAT
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" }, readOnly: true }}
              required
              size="small"
              name="numberPlate"
              value={formData.numberPlate}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              NAMA MEREK
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" }, readOnly: true }}
              required
              size="small"
              name="brand"
              value={formData.brand}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              NAMA MODEL
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" }, readOnly: true }}
              required
              size="small"
              name="model"
              value={formData.model}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TIPE KENDARAAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" }, readOnly: true }}
              required
              size="small"
              name="vehicleType"
              value={formData.vehicleType}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <div className={styles.footerButton}>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/admin/kendaraan-pengiriman")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
